module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAARklEQVQ4y2NgGBzAYvJ/svDgNqCq3ve/bXQBeQYsnGqGlY3TgP/I4H7cfwyATQwI4AacE1T7Tw6mngsoDgOqxwLp6WBIAwD77lUokZELJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CV.png
// module id = 1117
// module chunks = 0